class ChallengeListScreenController  {

    constructor() {

        this.pendingChallenges = null;
        this.historyChallenges = null;

        $(document).on("click", '.challengePlayerImageBtn', function(e) {
            var gameId = $(this).attr('data-gameid');
            api.getChallengeInfo(world.token,gameId,'CHALLENGE_FINISHED','close');

            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        $(document).on("click", '.challengeViewResultBtn', function(e) {

            let a = $(this);
            let cle = a.closest('.challenges-list-element');
            cle.find('.showOnResultViewed').removeClass('hide');
            cle.find('.hideOnResultViewed').addClass('hide');

            var gameId = $(this).attr('data-gameid');
            api.getChallengeInfo(world.token,gameId,'CHALLENGE_FINISHED','close');

            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        $(document).on("click", '.challengeAcceptBtn', function(e) {

            if (user.isSupervisor()) {

                WorldHomeController.showSupervisorAccessDeniedAlert();

            } else if (world.isClosed()) {

                WorldHomeController.showWorldClosedAlert();

            } else if(!world.isFinishedOrExpired()) {
                var gameId = $(this).attr('data-gameid');
                var dataUserName = $(this).attr('data-username');

                swal({
                        title: "",
                        text: sprintf(Translator.trans('TR_DESEA_ACEPTAR_EL_RETO_CON_EL_USUARIO_PLACEHOLDER'),dataUserName),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "",
                        closeOnConfirm: true
                    },
                    function(isConfirm){
                        if (isConfirm) {
                            ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_ACCEPT_CHALLENGE,'LIST_OF_CHALLENGES');
                            api.getChallengeInfo(world.token,gameId,'ACCEPT_CHALLENGE',true);
                        }

                    });

            }

            e.preventDefault();
            e.stopPropagation();
            return false;
        });

        $(document).on("click", '.cloneChallengeListBtn', function(e) {

            if (user.isSupervisor()) {

                WorldHomeController.showSupervisorAccessDeniedAlert();

            } else if (world.isClosed()) {

                WorldHomeController.showWorldClosedAlert();

            } else if(!world.isFinishedOrExpired()) {

                var gameId = $(this).attr('data-gameid');
                var dataUserName = $(this).attr('data-username');

                swal({
                        title: "",
                        text: sprintf(Translator.trans('TR_DESEA_PEDIR_REVANCHA_AL_USUARIO_PLACEHOLDER'),dataUserName),
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "",
                        closeOnConfirm: true
                    },
                    function(isConfirm){
                        if (isConfirm) {
                            ga('send', 'event', analytics.GA_CATEGORY_PLAY, analytics.GA_CATEGORY_PLAY_EVENT_REMATCH,'LIST_OF_CHALLENGES');
                            api.getChallengeInfo(world.token,gameId,'REVENGE_CHALLENGE',true);
                        }

                    });
            }

            e.preventDefault();
            e.stopPropagation();
            return false;
        });
    };

    drawPendingChallenges() {

        let pendingChallengesCount = 0;

        if (this.pendingChallenges) {
            _.forEach(this.pendingChallenges.challenges, function (challenge) {
                if (challenge.game.user_world_creator_id != user.user_world_id) {
                    pendingChallengesCount++;
                }
            });
        }

        if (pendingChallengesCount > 0) {
            $('#baseBadgeChallengesTxt').text(pendingChallengesCount);
        }

    }
}